import React, { useState, useEffect } from "react"
import {
  Card,
  CardContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Paper,
  Box,
} from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import { useNavigate, useParams } from "react-router-dom"
import { can } from "../../Conections/LogConections"
import { GetStudentListAPI } from "../../Conections/AcademicConection"
import { useAuth } from "../../Auth/AuthProvider"

// Simulación de datos de la API
const apiData1 = {
  estudiantes: [
  ],
  fechas: [
  ],
}

// Función para calcular si cumple con el mínimo de asistencias (por ejemplo, 70%)
const cumpleMinimo = (sesiones) => {
  const totalSesiones = sesiones.length
  const asistencias = sesiones.filter((s) => s === 1).length
  return asistencias / totalSesiones >= 0.8
}

// Función para formatear la fecha y hora
const formatFecha = (fechaString) => {
  const fecha = new Date(fechaString)
  return fecha.toLocaleString("es-ES", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export default function StudentListShow() {

  const goTo = useNavigate();
  const { getToken, getCompany } = useAuth();
  const { group } = useParams();

  const [apiData, setApiData] = useState(apiData1)
  const [searchTerm, setSearchTerm] = useState("")
  const [estudiantes, setEstudiantes] = useState([])
  const [fechas, setFechas] = useState([])

  React.useEffect(() => {
    async function reloaduser() {
      if (getToken()) {
        const permisionCan = await can(getToken(), getCompany(), "/academic/studentlistshow/:group");
        if (permisionCan === 0) {
          goTo("/dashboard");
        }
        else {
          let Data = await GetStudentListAPI(getToken(), getCompany(), group);
          console.log(Data);
          setApiData(Data);
          setEstudiantes(Data.estudiantes)
          setFechas(Data.fechas)
        }
      }
      else {
        goTo(`/login`);
      }
    };
    reloaduser();
  }, [group, getCompany, getToken, goTo]);

  // Filtrar estudiantes basado en el término de búsqueda
  const filteredEstudiantes = estudiantes.filter(
    (estudiante) =>
      estudiante.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
      estudiante.apellido.toLowerCase().includes(searchTerm.toLowerCase()) ||
      estudiante.codigo.toLowerCase().includes(searchTerm.toLowerCase()),
  )

  return (
    <Box sx={{ margin: 2 }}>
      <Typography variant="h5" gutterBottom>
        Asistencias a Secciones
      </Typography>

      <Card sx={{ marginBottom: 2 }}>
        <CardContent>
          <TextField
            fullWidth
            placeholder="Buscar estudiante..."
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            InputProps={{
              startAdornment: <SearchIcon sx={{ color: "action.active", mr: 1 }} />,
            }}
          />
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Box sx={{ overflow: 'auto', maxWidth: '100%' }}>
            <Box sx={{ width: '100%', display: 'table', tableLayout: 'fixed' }}>
              <TableContainer component={Paper} sx={{ maxHeight: 440 }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ minWidth: 100, position: 'sticky', left: 0, background: 'white', zIndex: 500 }}>Código</TableCell>
                      <TableCell sx={{ minWidth: 150, position: 'sticky', left: 100, background: 'white', zIndex: 500 }}>Nombre</TableCell>
                      <TableCell sx={{ minWidth: 150, position: 'sticky', left: 250, background: 'white', zIndex: 500 }}>Apellido</TableCell>
                      {fechas.map((fecha, index) => (
                        <TableCell key={index} align="center" >
                          {formatFecha(fecha)}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {filteredEstudiantes.map((estudiante) => (
                      <TableRow
                        key={estudiante.id}
                        sx={{
                          backgroundColor: cumpleMinimo(estudiante.sesiones)
                            ? 'lightgreen'
                            : 'lightcoral'
                        }}
                      >
                        <TableCell sx={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>{estudiante.codigo}</TableCell>
                        <TableCell sx={{ position: 'sticky', left: 100, background: 'white', zIndex: 1 }}>{estudiante.nombre}</TableCell>
                        <TableCell sx={{ position: 'sticky', left: 250, background: 'white', zIndex: 1 }}>{estudiante.apellido}</TableCell>
                        {estudiante.sesiones.map((asistio, index) => (
                          <TableCell key={estudiante.id+"."+index} align="center" >{asistio === 1 ? "✓" : "✗"}</TableCell>
                        ))}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </CardContent>
      </Card>

    </Box>
  )
}

